import { render, staticRenderFns } from "./SettingsBotSnippetGoogleTagManager.vue?vue&type=template&id=73959188&"
import script from "./SettingsBotSnippetGoogleTagManager.vue?vue&type=script&lang=js&"
export * from "./SettingsBotSnippetGoogleTagManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports